module.exports = __webpack_public_path__ + "static/media/how-it-works-large.57ad86d4.jpg";